// extracted by mini-css-extract-plugin
module.exports = {"TributContainer":"Memories_TributContainer__1sA79"};